export default __webpack_public_path__ + "assets/img_della8_tool-c2d9dd43.png";